import React, {useState} from "react";
import formValid from "../components/UI/formValid";
import myaxios from "../components/Axios";
import Notif from "../components/Notif";
import Modal from "../components/Modal";
import {FieldGen, setField} from "../components/fieldGen";
import {withRouter} from "react-router-dom";

const EmailCampaigns = ({ close, history, isOpen }) => {
    const [state, setMyState] = useState({
        formControl: {
            name: {
                type: 'input',
                label: 'Название списка',
                value: '',
                valid: true,
                validation: {required: true}
            },
        },
        loading: true
    })

    const setState = (st, func) => {
        Object.keys(st).map((key) => { state[key] = st[key]});
        setMyState(prevState => { return {...prevState, ...state} });
        if(func) func();
    };

    const isFormValid = () => {
        let formControl = state.formControl;
        let isFormValid = true;
        Object.keys(formControl).map((key, index) => {
            formControl[key].valid = formValid(formControl[key].value, formControl[key].validation)
            isFormValid = formControl[key].valid && isFormValid
        });
        setState({ formControl });
        return isFormValid;
    };

    const save = () => {
        if(!isFormValid()) return false

        let result = {};
        Object.keys(state.formControl).map(key => {result[key] = state.formControl[key].value})

        myaxios.post(`/ajax/mail/broadcast/campaign`, result).then(res => {
            if(res.status === 200 || res.status === 201) {
                Notif("save");
                history.push(`/marketing/mail/campaigns/${res.data.id}`)

            }
        })
    }

    return <Modal isOpen={isOpen} title="Создать список" save={save} close={close}>
        <FieldGen
            arr={state.formControl}
            setField={(e, type) => setState({formControl: setField(state.formControl, type, e)})}
        />
    </Modal>
}

export default withRouter(EmailCampaigns)